<template>
 <d-row>
      <d-col lg="12">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span> 
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Simpan</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>
                <!-- Full Name -->
                <d-col md="6" :class="{ 'form-group--error' : $v.fullname.$error }">
                  <label for="feFullName">Nama Lengkap</label>
                  <d-form-input type="text" id="name" placeholder="Nama Lengkap" v-model.trim="$v.fullname.$model" />
                  <div  class="verror" v-if="!loading && !$v.fullname.required">Harap isi kolom ini</div>
                </d-col>

                <!-- dob -->
                <d-col md="6" :class="{ 'form-group--error' : $v.dob.$error }">
                  <d-row>
                    <d-col md=6>
                      <label for="feFullName">Tgl Lahir
                      </label>
                      <d-datepicker v-model.trim="dob"></d-datepicker>
                      <div  class="verror" v-if="!loading && !$v.dob.required">Harap isi kolom ini</div>
                    </d-col>
                    <d-col md=6>
                      <label for="feNoDob">Tidak ada data Tgl Lahir
                      </label>
                      <d-checkbox v-model="no_dob" toggle />                  
                    </d-col>
                  </d-row>
                </d-col>

              <!-- mobile phone -->
                <d-col md="6" class="form-group">
                  <d-row>
                    <d-col md=6>
                      <label for="femobile_phone">HP</label>
                      <d-form-input type="text" id="mobile_phone" placeholder="Nomor HP" v-model.trim="mobile_phone" />
                    </d-col>
                    <d-col md=6>
                      <label for="feNoHP">Tidak ada data no HP
                      </label>
                      <d-checkbox v-model="no_hp" toggle />                  
                    </d-col>
                  </d-row>
                </d-col>

              </d-form-row>

              <d-form-row>
                <!-- email -->
                <d-col md="6" class="form-group">
                  <label for="feEmail">Email</label>
                  <d-form-input type="text" id="email" placeholder="alamat email" v-model.trim="email" />
                </d-col>
              </d-form-row>

              <!-- Address -->
              <d-form-row>
                <d-col md="12" class="form-group">
                <label for="feInputAddress">Alamat</label>
                <textarea 
                    class="form-control w-100"
                    v-model.trim="address"
                    placeholder="Alamat"
                    rows="3"
                    max-rows="6">{{ address }}
                </textarea>
               </d-col>
              </d-form-row>

              <!-- Memo -->
              <d-form-row>
                <d-col md="12" class="form-group">
                <label for="feInputMemo">Memo</label>
                <textarea 
                    class="form-control w-100"
                    v-model.trim="memo"
                    placeholder="Memo"
                    rows="3"
                    max-rows="6">{{ memo }}
                </textarea>
               </d-col>
              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import { required } from 'vuelidate/lib/validators';
import env from '../../env.vue';

export default {
  components: {
    VueElementLoading,
  },
  name: 'person-info',
  data(){
    return {
      form:'',
      id:'',
      dob:'',
      old_dob:'',
      old_hp:'',
      no_dob:false,
      no_hp:false,
      fullname:'',
      memo:'',
      email:'',
      address:'',
      mobile_phone:'',
      created_at:'',
      loading:false,
      old_data:[],
      error_msg:'',
      show_alert:false,
    }
  },
  validations:{
    fullname:{ required },
    dob:{ required },
    dtype:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
    no_dob( val ){
       if ( val ) {
          this.old_dob=this.dob;
          this.dob='1900-01-01';
       } else {
          if (this.old_dob=='1900-01-01'){
             let dt = new Date();
             this.old_dob=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
           }
          this.dob=this.old_dob;
       }
    },
    no_hp( val ){
       if ( val ) {
          this.old_hp=this.mobile_phone;
          if(this.old_hp=='0000000') this.old_hp='';
          this.mobile_phone='0000000';
       } else {
          this.mobile_phone=this.old_hp;
          this.old_hp='';
       }
    }
  },
  methods: {

    save_form(){
        let dthis=this;        
        let submit=false;
        Object.keys(this.old_data).forEach( key=>{
          if ( JSON.stringify(eval('dthis.'+key))!==JSON.stringify(eval('dthis.old_data.'+key)) ){
            submit=true;
          }
        });
        if(this.fullname==''){
            alert('Harap isi nama lengkap');
            return;
        }
        if(this.dob==''){
            alert('Harap isi tgl lahir');
            return;
        }
        if (submit){
          this.loading=true;          
          let d = new Date(this.dob);
          let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
          let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d)
          let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)          
          let ddate = `${ye}-${mo}-${da}`;
          let arr={};
          if (this.id==0)this.created_at='2023-10-10T10:10:00.000000Z';
          arr={
            fullname:this.fullname,
            address:this.address,
            mobile_phone:this.mobile_phone,
            dob:ddate,
            created_at:this.created_at,
            email:this.email,
            created_by:0,
            memo: this.memo,
          };
          this.axios.post( env.server+'/person/save/'+this.id, arr
          ).then( resp=>{
            resp=JSON.parse(resp.data);
            this.loading=false;
            if (resp.message=='Duplicate Person'){
              this.pop_alert('Non Donatur dengan nama dan nomor HP yg diisi sudah ada');
              return;
            }
            if (this.id==0)this.id=resp.data[0];
            this.$buefy.toast.open({ message:'Data berhasil disimpan',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            this.pop_alert(JSON.parse(e.response.data));
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=5;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      id:'',
      fullname:'',
      dob:'',
      address:'',
      mobile_phone:'',
      created_at:'',
      email:'',
      memo:'',
      }
      Object.keys(this.old_data).forEach( key=>{
        if (key!='gender')
          eval('dthis.'+key+'=\'\'');
      });        
    },
    loadForm(){
      this.loading=true;
      if ( this.locations==[] || this.organizations==[] ){
        setTimeout(()=>{this.loadForm();},500);
        return;
      }
      this.axios.get( env.server+'/person/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.fullname=resp.data.fullname;
          this.dob=resp.data.dob;
          this.mobile_phone=resp.data.mobile_phone;
          this.address=resp.data.address;
          this.loading=false;
          this.old_data=resp.data,
          this.created_at=resp.data.created_at,
          this.email=resp.data.email;
          this.memo=resp.data.memo;
          
          this.filter_cats();
          if (this.dob=='1900-01-01')this.no_dob=true;
          if (this.mobile_phone=='0000000'){this.no_hp=true;this.old_hp='';}
        }
      );
    },
  },
  mounted(){
    this.id=this.$route.query.id;
    if ( this.id>0 ){
        setTimeout(()=>{this.loadForm();},100);
    } else {
      this.resetForm()
      let arr=this.$store.state.list;
      var dt = new Date();
      this.dob=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
    }
  },
};
</script>
